let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eYOjB")).then(() => parcelRequire('6zdul'));